import type React from "react";
import { useState } from "react";

type Props = {
  children: React.ReactNode;
  isLoading: boolean;
  handleSubmit: () => void;
};

const styles = { color: "#fff" };

export const LayoutCheckoutForm = ({
  handleSubmit,
  isLoading,
  children,
}: Props): JSX.Element => {
  const handleOnClickSubmit = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();
    handleSubmit();
  };

  return (
    <form
      className="ps-form--checkout"
      method="post"
      onSubmit={handleOnClickSubmit}>
      <div className="ps-form__billing-info">{children}</div>
      <div className="form-group text_Center___develop">
        <button
          type="submit"
          className="ps-btn develop__buttons btn__develop__movil"
          disabled={isLoading}
          style={styles}>
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-md"
                role="status"
                aria-hidden="true"></span>
              <span className="ml-4">Procesando ...</span>
            </>
          ) : (
            "Generar ticket de pago"
          )}
        </button>
      </div>
    </form>
  );
};
